export default __webpack_public_path__ + "static/media/nytimes.181df6bd.jpg";